export default __webpack_public_path__ + "static/fonts/Jaymont-Medium.2843c1f.woff2";